import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export default function TierCard({ tier, selected, onSelect, testIdPrefix = "tier" }) {
  const highlighted = tier.highlighted;

  return (
    <div
      data-testid={`${testIdPrefix}-${tier.id}`}
      className={cn(
        "tier-card relative flex flex-col bg-white border rounded-none p-8 lg:p-10",
        highlighted ? "border-[#C03028]" : "border-[#E3DED5]",
        selected && "ring-1 ring-[#C03028] border-[#C03028]"
      )}
    >
      {highlighted && (
        <div
          data-testid={`tier-${tier.id}-badge`}
          className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-[#C03028] text-[#FAF9F6] text-[10px] uppercase tracking-[0.22em]"
        >
          Most chosen
        </div>
      )}

      <div className="eyebrow">{tier.tagline}</div>

      <h3 className="font-serif-display text-3xl lg:text-4xl mt-3 text-[#2A1F1A]">
        {tier.name}
      </h3>

      <div className="mt-5 flex items-baseline gap-2">
        <span className="font-serif-display text-5xl text-[#2A1F1A]">
          {tier.commission}
        </span>
        <span className="text-sm text-[#6E6E70]">commission</span>
      </div>

      <p className="mt-5 text-sm leading-relaxed text-[#6E6E70]">
        {tier.description}
      </p>

      <ul className="mt-7 space-y-3 flex-1">
        {tier.features.map((f) => (
          <li
            key={f}
            className="flex items-start gap-3 text-sm text-[#2A1F1A]"
          >
            <Check
              className="mt-0.5 shrink-0 text-[#B0895C]"
              size={16}
              strokeWidth={2}
            />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => onSelect(tier.id)}
        data-testid={`btn-select-${tier.id}`}
        className={cn(
          "mt-8 w-full py-3 text-sm tracking-wide rounded-none",
          highlighted || selected
            ? "btn-primary"
            : "btn-secondary"
        )}
      >
        {selected ? "Selected" : `Choose ${tier.name}`}
      </button>
    </div>
  );
}
